import { useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { useDataManagement } from "../ferramentas/RequisitarAPI.ts";
import style from "./Home.module.css";
import CardFlipante from "../ferramentas/cardFlipante/CardFlipante.js";
import ToastMessage from "../ferramentas/toastMessage/ToastMessage";
import Logo from "../logo/Logo.js";
import LogoApe from "../logo/LogoApe.js";
import Placeholder from "../ferramentas/placeholder/Placeholder.js";
import Cookies from 'js-cookie';

function Home({ logIn = false }) {
  const { login, load, error } = useDataManagement();
  const navigate = useNavigate();
  const location = useLocation();

  const [form, setForm] = useState({ email: "", senha: "", nome: "" });
  // Novo estado para o formulário de recuperação de senha
  const [formRecuperacao, setFormRecuperacao] = useState({ email: "" });


  // 0 = Frente (Bem-vindo), 1 = Verso (Login), 2 = Terceiro Lado (Recuperar Senha)
  const [ladoDoCard, setLadoDoCard] = useState(logIn ? 1 : 0);

  const [loginAttempts, setLoginAttempts] = useState(0);
  const maxLoginAttempts = 5;
  const timeBlocked = 1;
  const [isLocked, setIsLocked] = useState(false);

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (isLocked) {
      ToastMessage({ cod: "e", texto: "Muitas tentativas de login. Por favor, tente novamente mais tarde." });
      return;
    }
    if (!form.email || !form.senha) {
      ToastMessage({ cod: "e", texto: "Por favor, preencha todos os campos" });
      return;
    }
    const newAttempts = loginAttempts + 1;
    setLoginAttempts(newAttempts);
    if (newAttempts >= maxLoginAttempts) {
      setIsLocked(true);
      ToastMessage({ cod: "e", texto: `Muitas tentativas de login. Bloqueado por ${timeBlocked} minuto(s).` });
      setTimeout(() => {
        setIsLocked(false);
        setLoginAttempts(0);
      }, timeBlocked * 60 * 1000);
      return;
    }
    try {
      const result = await login(form.email, form.senha);
      if (result.ok) {
        setLoginAttempts(0);
        navigate("/admin/calendario");
      } else {
        ToastMessage({ cod: "e", texto: "Falha no login. Verifique suas credenciais." });
      }
    } catch (error) {
      console.error("Erro ao realizar login:", error);
      ToastMessage({ cod: "e", texto: "Ocorreu um erro ao processar o login. Tente novamente." });
    }
  };

  // Nova função para o formulário de recuperação de senha
  const handleRecuperacaoSubmit = async (e) => {
    e.preventDefault();
    if (!formRecuperacao.email) {
      ToastMessage({ cod: "e", texto: "Por favor, informe seu e-mail." });
      return;
    }
    // Aqui você adicionaria a lógica para chamar sua API de recuperação de senha
    console.log("Pedido de recuperação de senha para:", formRecuperacao.email);
    ToastMessage({ cod: "s", texto: "Se o e-mail estiver cadastrado, um link de recuperação será enviado." });
    // Opcional: voltar para a tela de login após a submissão
    setLadoDoCard(1);
  };

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  // Novo handler para o campo de e-mail de recuperação
  const handleChangeRecuperacao = (e) => {
    setFormRecuperacao((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleAdminClick = async () => {
    const token = Cookies.get("tokenizacao");
    if (token) {
      navigate("/admin/calendario");
    } else {
      // 2. ATUALIZAÇÃO: Altera o estado para o lado 1 (login)
      setLadoDoCard(1);
    }
  };

  // Demais useEffects permanecem os mesmos...
  useEffect(() => {
    if (error) ToastMessage({ cod: "e", texto: "Ocorreu um erro inesperado. Tente novamente." });
  }, [error]);

  useEffect(() => {
    if (location.state?.message) {
      ToastMessage({ cod: "e", texto: location.state?.message });
      location.state = null;
    }
  }, [location]);

  useEffect(() => {
    const lockUntil = localStorage.getItem('loginLockUntil');
    if (lockUntil && parseInt(lockUntil) > Date.now()) {
      setIsLocked(true);
      const timeRemaining = parseInt(lockUntil) - Date.now();
      setTimeout(() => {
        setIsLocked(false);
        setLoginAttempts(0);
        localStorage.removeItem('loginLockUntil');
      }, timeRemaining);
    }
  }, []);

  useEffect(() => {
    if (isLocked) {
      const lockUntil = Date.now() + (15 * 60 * 1000);
      localStorage.setItem('loginLockUntil', lockUntil.toString());
    }
  }, [isLocked]);


  return (
    <div className={style.home}>
      <div className={style.logo_wrapper}>
        <LogoApe />
        <Logo layout="login" />
      </div>
      <CardFlipante
        // 3. ATUALIZAÇÃO: Passa a prop 'lado' em vez de 'flipado'
        lado={ladoDoCard}
        frente={
          <div className={style.card}>
            <h1 className={style.home_title}>Bem-vindo</h1>
            <p>Qual o tipo de acesso?</p>
            <div>
              <button onClick={handleAdminClick}>Admin</button>
              <button onClick={() => navigate("/cliente")}>Cliente</button>
            </div>
          </div>
        }
        style_verso={style.verso}
        style_frente={style.frente}
        style_terceiro={style.verso}
        verso={
          !load.isLoading ? (
            <div className={style.login_form}>
              <h1 className={style.home_title}>Login</h1>
              <form onSubmit={handleFormSubmit}>
                {/* ... inputs de email e senha ... */}
                <div className={style.input_wrapper}>
                  <Placeholder
                    label="Email" type="email" name="email"
                    value={form.email} onChange={handleChange}
                    required disabled={isLocked}
                  />
                </div>
                <div className={style.password_wrapper}>
                  <Placeholder
                    label="Senha" type="password" name="senha"
                    value={form.senha} onChange={handleChange}
                    required disabled={isLocked}
                  />
                </div>
                <div className={style.btn_wrapper}>
                  <button type="submit" className={style.submitBtn} disabled={isLocked}>
                    Entrar
                  </button>
                  <button
                    type="button" // Boa prática para botões que não submetem forms
                    className={style.voltarBtn}
                    onClick={(e) => {
                      e.preventDefault();
                      // 4. ATUALIZAÇÃO: Volta para o lado 0
                      setLadoDoCard(0);
                    }}
                  >
                    Voltar
                  </button>
                </div>
              </form>
              {/* 5. ATUALIZAÇÃO: 'a' vira 'button' para controlar o flip */}

              <a
                href="/caminho"
                className={style.forgot_password}
                onClick={(e) => {
                  e.preventDefault(); // Impede a navegação padrão do link
                  setLadoDoCard(2);   // Executa a sua lógica para virar o card
                }}
              >
                Esqueceu sua senha?
              </a>

              {isLocked && (
                <p className={style.lockMessage}>
                  Login bloqueado devido a muitas tentativas. Tente novamente mais tarde.
                </p>
              )}
            </div>
          ) : (
            <div className={style.loading}>{load.reason}</div>
          )
        }
        // 6. NOVO: Adiciona o conteúdo para o terceiro lado
        terceiroLado={
          <div className={style.login_form}> {/* Reutilizando o estilo do form */}
            <h1 className={style.home_title}>Recuperar Senha</h1>
            <form onSubmit={handleRecuperacaoSubmit}>
              <div className={style.input_wrapper}>
                <Placeholder
                  label="Seu Email"
                  type="email"
                  name="email"
                  value={formRecuperacao.email}
                  onChange={handleChangeRecuperacao}
                  required
                />
              </div>
              <div className={style.btn_wrapper}>
                <button type="submit" className={style.submitBtn}>
                  Enviar
                </button>
                <button
                  type="button"
                  className={style.voltarBtn}
                  onClick={(e) => {
                    e.preventDefault();
                    // Volta para a tela de login (lado 1)
                    setLadoDoCard(1);
                  }}
                >
                  Voltar
                </button>
              </div>
            </form>
          </div>
        }
      />
    </div>
  );
}

export default Home;